import { Input, InputProps } from '@heroui/react'
import { Field, FieldProps } from 'formik'
import { motion } from 'framer-motion'
import { useState } from 'react'

type CustomInputProps = Omit<InputProps, 'type' | 'endContent'>

export interface InputPasswordFormikProps extends CustomInputProps {
  name: string
  label: string
  classNameContainer?: string
  variant?: 'flat' | 'bordered' | 'faded' | 'underlined'
  classNames?: {
    label?: string[]
    input?: string[]
    innerWrapper?: string
    inputWrapper?: string[]
  }
}

const InputPasswordFormik = ({
  label,
  classNameContainer,
  name,
  classNames,
  ...props
}: InputPasswordFormikProps) => {
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const handleTogglePassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <motion.div className={classNameContainer}>
          <Input
            radius="sm"
            variant="bordered"
            {...field}
            {...props}
            className="h-full"
            errorMessage={meta.error && meta.touched ? meta.error : ''}
            isInvalid={meta.error && meta.touched ? true : false}
            label={label}
            labelPlacement="outside"
            type={showPassword ? 'text' : 'password'}
            classNames={{
              label: [
                'text-foreground',
                'dark:text-foreground',
                'group-data-[filled-within=true]:text-foreground',
                'dark:group-data-[filled-within=true]:text-white',
                'group-data-[invalid=true]:text-danger',
                'dark:group-data-[invalid=true]:text-danger',
              ],
              input: [
                'bg-transparent',
                'text-foreground',
                'dark:text-white',
                'placeholder:text-default-400',
                'dark:placeholder:text-white/60',
                'group-data-[invalid=true]:placeholder:text-danger',
              ],
              innerWrapper: 'bg-transparent',
              inputWrapper: [
                'bg-default-50',
                'dark:bg-[#1e1e20]',
                'border-default-200',
                'dark:border-default-600',
                'hover:bg-default-100',
                'dark:hover:bg-[#1e1e20]/70',
                'group-data-[focus=true]:bg-default-100',
                'dark:group-data-[focus=true]:bg-[#1e1e20]/50',
                'group-data-[focus=true]:border-primary',
                'dark:group-data-[focus=true]:border-primary',
                '!cursor-text',
              ],
              ...classNames,
            }}
            endContent={
              <button className="focus:outline-none" type="button" onClick={handleTogglePassword}>
                <span className="text-tertiary text-sm">{showPassword ? 'Hide' : 'Show'}</span>
              </button>
            }
          />
        </motion.div>
      )}
    </Field>
  )
}

export default InputPasswordFormik
